var _path, _path2, _line, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.75,9.55c-1.21,0 -2.2,0.99 -2.2,2.21c0,1.21 0.99,2.2 2.2,2.2c1.22,0 2.21,-0.99 2.21,-2.2c0,-1.22 -0.99,-2.21 -2.21,-2.21z",
    fill: "#000000",
    id: "svg_1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.75,5.39c-2.56,0 -4.87,1.03 -6.53,2.3c-0.83,0.64 -1.51,1.35 -1.99,2.04c-0.47,0.68 -0.78,1.39 -0.78,2.03c0,0.63 0.31,1.34 0.78,2.02c0.48,0.69 1.16,1.4 1.99,2.04c1.66,1.27 3.97,2.3 6.53,2.3c2.57,0 4.88,-1.03 6.54,-2.3c0.83,-0.64 1.51,-1.35 1.99,-2.04c0.47,-0.68 0.78,-1.39 0.78,-2.02c0,-0.64 -0.31,-1.35 -0.78,-2.03c-0.48,-0.69 -1.16,-1.4 -1.99,-2.04c-1.66,-1.27 -3.97,-2.3 -6.54,-2.3zm-3.67,6.37c0,-2.03 1.65,-3.68 3.67,-3.68c2.03,0 3.68,1.65 3.68,3.68c0,2.02 -1.65,3.67 -3.68,3.67c-2.02,0 -3.67,-1.65 -3.67,-3.67z",
    fill: "#000000",
    fillRule: "evenodd",
    id: "svg_2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_4",
    stroke: "null",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 2.54,
    x2: 21.05,
    y1: 17.84,
    y2: 5.32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 21.55,
    id: "svg_5",
    stroke: "#ffffff",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    transform: "rotate(53.8031, 11.8579, 11.7529)",
    width: 2.11,
    x: 10.8,
    y: 0.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eye-crossed.199e1dd0b33e4b66192a1ed7bfb8cb78.svg";
export { ForwardRef as ReactComponent };